import * as d3 from 'd3'
import debounce from '@/utils/debounce';

class Bubbles {
	constructor({
		el =  document.body,
		margin = {top: 10, left: 10, right: 10, bottom: 10},
		className = 'knd-chart',
		maxHeight = undefined
	} = {}) {
		this.graphicContainer = d3.select(el);
		this.margin = margin;
		this.className = className;
		this.maxHeight = maxHeight;


		this.checkWidth();
		this.checkHeight();

		window.addEventListener('resize', debounce(() => this.resize(), 250));	
	}

	init() {
		this.drawSvg();
	}

	drawSvg(className) {
		this.svg = this.graphicContainer.append('svg')
			.attr('class', `${this.className}` )
		
		this.g = this.svg.append('g')
			.attr('transform',  `translate(${this.margin.left}, ${this.margin.top})`);

		this.gAxis = this.svg.append('g')
			.attr('class',  `knd-axis`);

		this.updateSvgSize();
	}

	updateSvgSize() {
		this.svg
			.attr('width', this.width() + this.margin.left + this.margin.right)
			.attr('height', this.height() + this.margin.top + this.margin.bottom)					
	}

	getParentWidth() {
		const parentNode = this.graphicContainer.node();
		if(!parentNode) return;
		const bbox = parentNode.getBoundingClientRect();
		return bbox.width;
	}

	getParentHeight() {
		const parentNode = this.graphicContainer.node();
		if(!parentNode) return;
		const bbox = parentNode.getBoundingClientRect();
		let height = bbox.height;

		if(this.maxHeight && this.maxHeight < height) height = this.maxHeight;

		return Math.floor(height);
	}	

	checkWidth() {
		this.width(this.getParentWidth())
	}

	checkHeight() {
		this.height(this.getParentHeight())
	}	

	width(value) {
		if(!value) return this._width;

		if(typeof value === 'number') {
			this._originalWidth = value;
			this._width = value - this.margin.left - this.margin.right;
		}
		else {
			this.checkWidth();
		}

		return this;
	}

	height(value) {
		if(!value) return this._height;

		if(typeof value === 'number') {
			this._originalHeight = value;
			this._height = value - this.margin.top - this.margin.bottom;
		} 
		else {
			this.checkHeight();
		}
		return this;
	}

	resize() {
		this.checkWidth();
		this.checkHeight();

		this.updateSvgSize();
	}

}

export default Bubbles;